import { useAction, useAtom } from '@reatom/npm-react'
import { useMemo } from 'react'

import { Button, RefreshIcon } from '@blade/ui-kit'

import { reatomBackOfficeWalletsRefreshBalancesModel } from '../atoms/reatom-back-office-wallets-refresh-model'

import type { DelugeId } from '@root/entities/user-short'
import type { WalletId } from '@root/entities/wallet'

export const BackOfficeRefreshUsersWalletsButton = (props: {
  wallets: Array<{
    delugeId: DelugeId
    walletId: WalletId
  }>
}) => {
  const model = useMemo(
    () =>
      // eslint-disable-next-line @reatom/unit-naming-rule
      reatomBackOfficeWalletsRefreshBalancesModel(props),
    [props],
  )
  const [requestState] = useAtom(model)
  const refreshUsersWallet = useAction(model.execute)
  return (
    <Button
      size="xxs"
      busy={requestState.loading}
      disabled={requestState.loading}
      iconLeft={<RefreshIcon />}
      variant="ghost"
      onClick={(e) => {
        e.preventDefault()
        e.stopPropagation()
        refreshUsersWallet()
      }}
    />
  )
}
